import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function NotFound() {
  const { t } = useLanguage();
  const nf = t.notFound;

  return (
    <section className="container-brand py-32 text-center" data-testid="not-found-page">
      <p
        className="inline-block text-[11px] font-display font-semibold uppercase tracking-[0.18em] px-3 py-1 rounded-full"
        style={{ background: "var(--brand-accent)", color: "#000" }}
      >
        404
      </p>
      <h1 className="mt-6 font-display font-bold text-5xl">{nf.title}</h1>
      <p className="mt-4 text-[#374151] max-w-md mx-auto">{nf.description}</p>
      <Link
        to="/"
        data-testid="not-found-home-cta"
        className="mt-8 inline-flex items-center px-5 py-2.5 rounded-full text-white font-display font-semibold"
        style={{ background: "var(--brand-primary)" }}
      >
        {nf.cta}
      </Link>
    </section>
  );
}
